import { create } from "zustand";
import { Notification } from "../../interfaces/Commons/Notifications/notifications";
import { NotificationStatus } from "../../interfaces/Commons/Notifications/notificationStatuses";
import { useNotificationStatusStore } from "./NotificationStatusStore";
import { devtools } from "zustand/middleware";



interface Notifications {
    notifications: Notification[];
    filteredNotifications: Notification[];
    unReadNotifications: number;
    setNotifications: (by: Notification[]) => void;
    addNotification: (by: Notification) => void;
    updateNotification: (by: Notification) => void;
    markAsRead: (notification: Notification) => void;
    markAsUnRead: (notification: Notification) => void;
    deleteNotification: (notification: Notification) => void;
    calculateUnReadNotifications: () => void;
    filterNotificationsByStatus: (status: NotificationStatus) => void;
    assingGetNotificationsError: (errorMessage: string | null) => void;
    getNotificationsError: string | null;
    lastNotificationId: number;
    mergeNotifications: (notifications: Notification[]) => void
}

export const useNotificationsStore = create<Notifications>()(
        (set, get) => ({
            notifications: [],
            lastNotificationId: 0,
            filteredNotifications: [],
            unReadNotifications: 0,
            setNotifications: (by: Notification[]) => {

                if (by.length === 0) {
                    return;
                }
                // Ordenar las notificaciones: No leídas (1) → Leídas (2) → Eliminadas (3)
                const sortedNotifications = [...by].sort((a, b) => a.notification_status_id! - b.notification_status_id!);

                set({ notifications: sortedNotifications, lastNotificationId: by[by.length - 1].notification_id, });
                get().calculateUnReadNotifications();
            },
            addNotification: (by: Notification) => {
                set((state) => ({ notifications: [...state.notifications, by] }));
                get().calculateUnReadNotifications();
            },
            updateNotification: (by: Notification) => {
                set((state) => ({
                    notifications: state.notifications.map((notification) =>
                        notification.notification_id === by.notification_id ? by : notification
                    ),
                }));
                get().calculateUnReadNotifications();
            },
            markAsRead: (notification: Notification) => {

                const { readStatus } = useNotificationStatusStore.getState();

                set((state) => ({
                    notifications: state.notifications.map((n) => n.notification_id === notification.notification_id
                        ? { ...n, notification_status_id: readStatus?.notification_status_id, read_at: new Date() }
                        : n)
                }));
                set((state) => ({
                    filteredNotifications: state.filteredNotifications.map((n) => n.notification_id === notification.notification_id
                        ? { ...n, notification_status_id: readStatus?.notification_status_id, read_at: new Date() }
                        : n)
                }));
                // const sortedNotifications = [...get().notifications].sort((a, b) => a.notification_status_id! - b.notification_status_id!);

                // set({ notifications: sortedNotifications });
                get().calculateUnReadNotifications();
            },
            markAsUnRead: (notification: Notification) => {

                const { unreadStatus } = useNotificationStatusStore.getState();

                set((state) => ({
                    notifications: state.notifications.map((n) => n.notification_id === notification.notification_id
                        ? { ...n, notification_status_id: unreadStatus?.notification_status_id }
                        : n)
                }));
                set((state) => ({
                    filteredNotifications: state.filteredNotifications.map((n) => n.notification_id === notification.notification_id
                        ? { ...n, notification_status_id: unreadStatus?.notification_status_id }
                        : n)
                }));
                // const sortedNotifications = [...get().notifications].sort((a, b) => a.notification_status_id! - b.notification_status_id!);

                // set({ notifications: sortedNotifications });
                get().calculateUnReadNotifications();
            },
            deleteNotification: (notification: Notification) => {

                const { deleteStatus } = useNotificationStatusStore.getState();

                set((state) => ({
                    notifications: state.notifications.filter((n) => n.notification_id !=notification.notification_id)
                }));
                set((state) => ({
                    filteredNotifications: state.filteredNotifications.filter((n) => n.notification_id !=notification.notification_id)
                }));
                // const sortedNotifications = [...get().notifications].sort((a, b) => a.notification_status_id! - b.notification_status_id!);

                // set({ notifications: sortedNotifications });
                get().calculateUnReadNotifications();
            },
            calculateUnReadNotifications: () => {

                const { unreadStatus } = useNotificationStatusStore.getState();

                const notifications = get().notifications;
                const unReadCount = notifications.filter((n) => n.notification_status_id === unreadStatus?.notification_status_id).length;
                set({ unReadNotifications: unReadCount })
            },
            filterNotificationsByStatus: (status: NotificationStatus) => {
                const notifications = get().notifications;
                if (status.notification_status_name === 'Todos') {
                    set({ filteredNotifications: notifications });
                    return;
                }
                set({ filteredNotifications: notifications.filter((n) => n.notification_status_id === status.notification_status_id) });
            },
            assingGetNotificationsError: (errorMessage: string | null) => {
                set({ getNotificationsError: errorMessage })
            },
            getNotificationsError: null,
            mergeNotifications: (newNotifications: Notification[]) => {
                set((state) => {
                    const existingNotifications = state.notifications;

                    const uniqueNotifications = newNotifications.filter(
                        (newNotification) =>
                            !existingNotifications.some(
                                (existing) => existing.notification_id === newNotification.notification_id
                            )
                    );

                    if (uniqueNotifications.length === 0) {
                        return {};
                    }

                    const updatedNotifications = [...existingNotifications, ...uniqueNotifications].sort(
                        (a, b) => a.notification_status_id! - b.notification_status_id!
                    );

                    const validNotificationIds = updatedNotifications
                        .map((n) => n.notification_id)
                        .filter((id): id is number => id !== undefined); // Filtra los valores undefined

                    const lastNotificationId = validNotificationIds.length > 0 ? Math.max(...validNotificationIds) : 0;

                    return {
                        notifications: updatedNotifications,
                        lastNotificationId,
                    };
                });

                get().calculateUnReadNotifications();
            }
        }));